import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { InstitutionsGetRequestModel, InstitutionsGetResponseModel } from "@/features/institutions/services/institutions-model";

export class InstitutionsApi {
  /**
   * 金融機関一覧取得
   */
  public getInstitutions = async (
    param: InstitutionsGetRequestModel
  ): Promise<InstitutionsGetResponseModel[]> => {
    const path = `/api/institutions`;
    const res = await ApiClient.instance.get<InstitutionsGetResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
